export { CommonCriteria as CommonCriteriaPage } from './CommonCriteria';
